import { StackFrame } from '../../../../../common/calls/models/StackFrame';
import { FilterStatus } from '../../../../../common/enums/FilterStatus';
import { RemediationTag } from '../../../../../common/enums/RemediationTag';
import { Severity } from '../../../../../common/enums/Severity';
import { TraceType } from '../../../../../common/enums/TraceType';
import { Remediation } from '../../../../../common/models/Remediation';

export class Instance {
  constructor(
    private readonly id: number,
    private readonly projectId: number,
    private readonly reportId: number,
    private readonly traceType: TraceType | null,
    private readonly localNumber: number,
    private readonly severity: Severity,
    private readonly data: string,
    private readonly filterStatus: FilterStatus,
    private readonly details: object | null,
    private readonly remediation: Remediation | null,
    private readonly specificRemediationTag: RemediationTag | null,
    private readonly hardCodedStringLocations: StackFrame[] | null,
    private readonly ruleNumber: number,
    private readonly ruleShortExplanation: string | null,
    private readonly ruleTitle: string,
    private readonly jiraExportUrl: string | null,
    private readonly serviceNowExportUrl: string | null
  ) {}

  getId() {
    return this.id;
  }

  getProjectId() {
    return this.projectId;
  }

  getReportId() {
    return this.reportId;
  }

  getTraceType() {
    return this.traceType;
  }

  getLocalNumber() {
    return this.localNumber;
  }

  getSeverity() {
    return this.severity;
  }

  getData() {
    return this.data;
  }

  getFilterStatus() {
    return this.filterStatus;
  }

  isKeptByFilters() {
    return this.filterStatus !== FilterStatus.NOT_KEPT;
  }

  getDetails() {
    return this.details;
  }

  getRemediation() {
    return this.remediation;
  }

  getSpecificRemediationTag() {
    return this.specificRemediationTag;
  }

  getHardCodedStringLocations() {
    return this.hardCodedStringLocations;
  }

  getRuleNumber() {
    return this.ruleNumber;
  }

  getShortExplanation() {
    return this.ruleShortExplanation ?? '';
  }

  getRuleTitle() {
    return this.ruleTitle;
  }

  getJiraExportUrl() {
    return this.jiraExportUrl;
  }

  getServiceNowExportUrl() {
    return this.serviceNowExportUrl;
  }
}
